<script lang="ts">
export default {
  name: 'Checkbox',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    modelValue?: boolean;
    label?: string;
    disabled?: boolean;
    indeterminate?: boolean;
    id?: string;
    class?: string;
  }>(),
  {
    disabled: false,
    indeterminate: false,
  },
);

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const checkboxId = computed(() => props.id || `checkbox-${Math.random().toString(36).slice(2, 11)}`);

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<template>
  <div :class="['form-control', props.class]">
    <label class="label flex cursor-pointer items-center justify-start gap-2">
      <input
        :id="checkboxId"
        type="checkbox"
        class="checkbox duration-75"
        :class="{ 'checkbox-disabled': disabled }"
        :checked="modelValue"
        :disabled="disabled"
        :indeterminate="indeterminate"
        @change="handleChange" />
      <span
        v-if="label"
        class="label-text text-sm text-gray-600"
        >{{ label }}</span
      >
    </label>
  </div>
</template>
